import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IOwnerList } from '../../../Pages/Owner/IOwner';

export const AddOwnerSlicer = createSlice({
  name: 'AddOwner',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IOwnerList>,
  reducers: {
    addOwner: (state, _) => {
      state.isLoading = true;
    },
    successAddOwner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddOwner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddOwnerState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addOwner,
  successAddOwner,
  failureAddOwner,
  clearAddOwnerState,
} = AddOwnerSlicer.actions;

export default AddOwnerSlicer.reducer;
